import {
  DOCUMENT_TYPE,
  DIALOG_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  MAC_OS_NAME,
  PO_EDIT_MODE,
  QS_CONSTANT,
  STARTMODE_WHEN_ROUTING,
  USE_REACT_ROUTER,
  VIA_PARTNER
} from '../define/global';
import {
  getDropboxAuthToken,
  getDropBoxFileContents,
  initDropboxAuthTokenInfo
} from '../extApis/dropBoxApi';
import { setViaPartner, setShareId, setViewAD, setShowUploadBtn } from '../store/modules/appData';
import { openDialog } from '../store/modules/dialog';
import { setEditMode, setFileName } from '../store/modules/docInfo';
import { showMobileBottomAD, showPopupAD } from '../store/modules/popup';
import { showToast } from '../store/modules/toast';
import ga from '../utils/gaConnect';

import { genNewFileName } from './FileControlUtil';
import { checkSupportNaverWorksDriveType, parseInfoFromUA } from './util';
import { getQSObject, getValueOfQSObject } from '../utils/qsUtils';
import { DropboxError, GoogleDriveError, WhaleSpaceError } from '../errors';
import { getDocumentFile, getGoogleDriveTokenInfo } from '../extApis/googleDriveApi';
import { CHANGE_FONT_TEMP_FILE_EXT } from './FontsUtil';
import { getWhaleSpaceTokenInfo } from '../extApis/whaleSpaceApi';
import { setAppLoading } from '../store/modules/appLoading';
import { setWhaleSpaceData } from '../store/modules/whaleSpaceData';
import axios from 'axios';
import { setNaverWorksFileInfo } from '../store/modules/naverWorksData';
import { getNaverWorksFile } from '../extApis/naverWorksApi';

const AppMainProcess = {};

AppMainProcess.getStartModeFromPath = (path, isPCView) => {
  let startMode = QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;

  if (path.endsWith('new')) {
    startMode = QS_CONSTANT.START_MODE.VALUES.NEW_DOC;
  }

  if (path.endsWith('shared')) {
    startMode = QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW;
  }

  if (path.endsWith('openRecent')) {
    startMode = QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC;
  }

  return startMode;
};

AppMainProcess.getStartModeFromMatch = (match) => {
  const startModeFromMath = match.params.startMode;

  switch (startModeFromMath) {
    case STARTMODE_WHEN_ROUTING.NEW_DOC:
      return QS_CONSTANT.START_MODE.VALUES.NEW_DOC;
    case STARTMODE_WHEN_ROUTING.OPEN_MOST_RECENT_DOC:
      return QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC;
    case STARTMODE_WHEN_ROUTING.SHARE_VIEW:
      return QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW;
    case STARTMODE_WHEN_ROUTING.NEW_DOC_FROM_ITT:
      return QS_CONSTANT.START_MODE.VALUES.NEW_DOC_FROM_ITT;
    case STARTMODE_WHEN_ROUTING.OPEN_DOC_FROM_ITT:
      return QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_ITT;
    case STARTMODE_WHEN_ROUTING.NEW_DOC_FROM_NAVERWORKS:
      return QS_CONSTANT.START_MODE.VALUES.NEW_DOC_FROM_NAVERWORKS;
    case STARTMODE_WHEN_ROUTING.OPEN_DOC_FROM_NAVERWORKS:
      return QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_NAVERWORKS;
    case STARTMODE_WHEN_ROUTING.VIEW_DOC_FROM_NAVERWORKS:
      return QS_CONSTANT.START_MODE.VALUES.VIEW_DOC_FROM_NAVERWORKS;
    case STARTMODE_WHEN_ROUTING.OPEN_DOCUMENT_OPENABLE_DIALOG:
    default:
      return QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;
  }
};

AppMainProcess.runWithDropBox = (dispatch, setRes) => {
  const query = getQSObject();
  const file_id = getValueOfQSObject(query, QS_CONSTANT.FILE_ID.KEY);
  const role = getValueOfQSObject(query, QS_CONSTANT.ROLE_TYPE.KEY);

  //const file_id = query.fileid;
  const oAutoToken = getDropboxAuthToken();
  getDropBoxFileContents(file_id, oAutoToken, role)
    .then((res) => {
      dispatch(setFileName(res.name));
      dispatch(showPopupAD());
      setRes(res);
      dispatch(setEditMode(PO_EDIT_MODE.READ));
      dispatch(setViewAD(false));
    })
    .catch((err) => {
      if (err instanceof DropboxError) {
        ga.exception({
          description: `
        status: ${err.code}
        message : ${err.message}
        call stack : ${err.stack}
        `
        });
        if (err.code === 401) {
          //Re Authorization
          initDropboxAuthTokenInfo();
          window.location.href = `/auth/dropboxAuth/index.html?file_id=${file_id}&require_role=${role}`;
        } else {
          dispatch(setAppLoading(false));
          dispatch(
            openDialog({
              dialogType: DIALOG_TYPE.DIALOG_DROPBOX_ERROR,
              arg: { error: { status: err.code, message: err.message } }
            })
          );
        }
      } else {
        throw new Error(err);
      }
    });
};

AppMainProcess.runWithGoogleDrive = async (dispatch, i18n, setRes) => {
  const query = getQSObject();
  const fileid = getValueOfQSObject(query, QS_CONSTANT.GOOGLE_DRIVE_FILE_ID.KEY);
  const action = getValueOfQSObject(query, QS_CONSTANT.GOOGLE_DRIVE_ACTION_TYPE.KEY);
  try {
    const tokenInfo = await getGoogleDriveTokenInfo();
    const documentFile = await getDocumentFile(tokenInfo.data.access_token, fileid);

    dispatch(setFileName(documentFile.name));
    dispatch(showPopupAD());
    setRes(documentFile);
    dispatch(setEditMode(PO_EDIT_MODE.READ));
  } catch (error) {
    const errorMessageTitle = 'Error Message: ';
    if (error instanceof GoogleDriveError) {
      if (error.code === 401) {
        window.open(
          `/api/v1/auth/googleDrive/reAuthorization?action=${action}&fileid=${fileid}`,
          '_self'
        );
      } else {
        const errorMessage =
          error.code === 403 ? i18n.t('Errors.GoogleDriveForbidden') : error.message;
        window.open(`/auth/confirmfail.html?error=${errorMessageTitle}${errorMessage}`, '_self');
      }
    } else {
      window.open(`/auth/confirmfail.html?error=${errorMessageTitle}${error.message}`, '_self');
    }
  }
};

AppMainProcess.runWithWhaleSpace = async (
  dispatch,
  i18n,
  recentFiles,
  { match, location, history },
  { setRes, setSU, setShareID }
) => {
  try {
    dispatch(setViewAD(false));
    ga.event({ category: '방문', action: match.params.startMode });

    const query = getQSObject();
    let startMode = USE_REACT_ROUTER
      ? AppMainProcess.getStartModeFromMatch(match)
      : getValueOfQSObject(query, QS_CONSTANT.START_MODE.KEY) ||
        QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;

    const qShareID = getValueOfQSObject(query, QS_CONSTANT.SHARE_ID.KEY);
    if (qShareID !== undefined && qShareID !== '')
      startMode = QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW;

    const { isPCView } = parseInfoFromUA();

    const getSdkMode = () => {
      switch (startMode) {
        case QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW:
        case QS_CONSTANT.START_MODE.VALUES.VIEW_DOC_FROM_NAVERWORKS: {
          if (
            DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SLIDE &&
            isPCView === false
          )
            return PO_EDIT_MODE.PRESENTATION;
          else return PO_EDIT_MODE.READ;
        }
        case QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_NAVERWORKS: {
          if (isPCView === false) {
            if (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SLIDE)
              return PO_EDIT_MODE.PRESENTATION;
            else return PO_EDIT_MODE.READ;
          } else {
            const mode =
              query.mode && query.mode.toLowerCase() === PO_EDIT_MODE.EDIT
                ? PO_EDIT_MODE.EDIT
                : PO_EDIT_MODE.READ;
            return mode;
          }
        }
        case QS_CONSTANT.START_MODE.VALUES.NEW_DOC:
        case QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC:
        case QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG:
        case QS_CONSTANT.START_MODE.VALUES.NEW_DOC_FROM_ITT:
        case QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_ITT:
        default: {
          if (isPCView === false) {
            if (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SLIDE)
              return PO_EDIT_MODE.PRESENTATION;
            else return PO_EDIT_MODE.READ;
          } else {
            return PO_EDIT_MODE.EDIT;
          }
        }
      }
    };

    const parseIttUrl = () => {
      const gsObj = getQSObject();
      const url = getValueOfQSObject(gsObj, 'url');
      const showUploadBtn =
        getValueOfQSObject(gsObj, 'showUploadBtn')?.toLowerCase() === 'false' ? false : true;
      let ittFilename = null;
      const filename = getValueOfQSObject(gsObj, 'ittFilename');
      if (filename) ittFilename = decodeURIComponent(filename);
      return { url, showUploadBtn, ittFilename };
    };

    const getNaverWorksDoc = async ({ naverWorksFileInfo }) => {
      try {
        const res = await getNaverWorksFile(
          naverWorksFileInfo.driveType,
          naverWorksFileInfo.driveId,
          naverWorksFileInfo.fileId
        );

        return res.file;
      } catch (error) {
        throw error;
      }
    };

    switch (startMode) {
      case QS_CONSTANT.START_MODE.VALUES.NEW_DOC:
      case QS_CONSTANT.START_MODE.VALUES.NEW_DOC_FROM_NAVERWORKS:
        {
          const fileName = genNewFileName();
          dispatch(setFileName(fileName));
        }

        break;
      case QS_CONSTANT.START_MODE.VALUES.NEW_DOC_FROM_ITT:
        {
          const fileName = genNewFileName();
          dispatch(setFileName(fileName));
          const { showUploadBtn } = parseIttUrl();
          dispatch(setShowUploadBtn(showUploadBtn));
          dispatch(setViaPartner(VIA_PARTNER.ITT));
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_ITT:
        {
          const { url: gsUrl, showUploadBtn, ittFilename } = parseIttUrl();
          dispatch(setShowUploadBtn(showUploadBtn));
          dispatch(setViaPartner(VIA_PARTNER.ITT));
          //const ss = encodeURIComponent("http://folio.itt.link/cmm/fms/FileDown.do?atchFileId=FILE_000000000204733&fileSn=1&test=한글")

          const errorControl = (url) => {
            if (url)
              history.push(
                '/error?title=아래 URL의 파일은 열 수 없습니다&msg=' + encodeURIComponent(url)
              );
            else history.push('/error?title=ERROR&msg=열고자 하는 URL이 없습니다.');
          };

          try {
            if (gsUrl === undefined) throw new Error();
            axios
              .get(decodeURIComponent(gsUrl), {
                responseType: 'arraybuffer'
              })
              .then((res) => {
                const fileName = ittFilename;
                if (!fileName) throw Error('No filename');

                const file = new File([res.data], fileName);

                setRes(file);
                dispatch(setFileName(fileName));
              })
              .catch((e) => {
                errorControl(e.message === 'No filename' ? `${gsUrl} (${e.message})` : gsUrl);
              });
          } catch (error) {
            errorControl(gsUrl);
          }
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_DOC_FROM_NAVERWORKS:
      case QS_CONSTANT.START_MODE.VALUES.VIEW_DOC_FROM_NAVERWORKS:
        {
          if (!query.driveType || checkSupportNaverWorksDriveType(query.driveType) === false) {
            throw new Error(`${query.driveType} : Invalid driveType.`);
          }

          const { fileInfo, file } = await getNaverWorksFile(
            query.driveType,
            query.driveId,
            query.fileId
          );

          dispatch(
            setNaverWorksFileInfo({
              driveType: query.driveType,
              driveId: query.driveId,
              folderId: fileInfo.parentFileId,
              fileId: fileInfo.fileId
            })
          );
          setRes(file);
          dispatch(setFileName(fileInfo.fileName));
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC:
        if (recentFiles) {
          try {
            const lastFile = recentFiles[0];
            if (lastFile) {
              const naverWorksFileInfo = lastFile.isNaverWorksFile
                ? lastFile.naverWorksFileInfo
                : null;
              const file = naverWorksFileInfo
                ? await getNaverWorksDoc({ naverWorksFileInfo })
                : lastFile.file;
              let fileName = file.name;
              const tmpExt = `${CHANGE_FONT_TEMP_FILE_EXT}`;
              if (fileName.endsWith(tmpExt)) {
                fileName = fileName.substring(0, fileName.length - tmpExt.length);
              }
              setRes(file);
              dispatch(setFileName(fileName));
              if (lastFile.isNaverWorksFile) {
                dispatch(setNaverWorksFileInfo(lastFile.naverWorksFileInfo));
              }
            } else {
              const fileName = genNewFileName();
              dispatch(setFileName(fileName));
            }
          } catch (error) {
            // window.open(`/auth/confirmfail.html?error=${t('NaverWorksFileNavigator.ForbiddenMessage')}`, '_self');
            if (error.code) {
              const errMessage = `${i18n.t('NaverWorksFileNavigator.InternalErrorMessage')} ( ${
                error.code
              } )`;
              window.open(`/auth/confirmfail.html?error=${errMessage}`, '_self');
            } else {
              window.open(
                `/auth/confirmfail.html?error=${i18n.t('AppMain.RecentFileOpenError')}`,
                '_self'
              );
              // dispatch(
              //   showToast({
              //     msg: i18n.t('AppMain.RecentFileOpenError')
              //   })
              // );
            }
          }
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW:
        const su = USE_REACT_ROUTER ? undefined : getValueOfQSObject(query, QS_CONSTANT.SU.KEY);
        const qShareID = USE_REACT_ROUTER
          ? match.params.docId
          : getValueOfQSObject(query, QS_CONSTANT.SHARE_ID.KEY);

        //const { shareID: qShareID, su } = query;
        if (su !== undefined) setSU(su === 'true');
        setShareID(qShareID);
        dispatch(setShareId(qShareID));

        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG:
      default:
        dispatch(
          openDialog({
            dialogType: DIALOG_TYPE.DIALOG_OPEN_DOCUMENT
          })
        );
        break;
    }

    dispatch(setEditMode(getSdkMode()));
  } catch (error) {
    window.open(`/auth/confirmfail.html?error=${error.toString()}`, '_self');
  }
};

AppMainProcess.runStandAlone = (dispatch, i18n, recentFiles, { setRes, setSU, setShareID }) => {
  StandAloneProductProcess.run(dispatch, i18n, recentFiles, {
    setRes,
    setSU,
    setShareID
  });
};

const StandAloneProductProcess = {
  getStartModeFromArg: (arg, isPCView) => {
    const qStartMode = getValueOfQSObject(arg, QS_CONSTANT.START_MODE.KEY);
    const qShareID = getValueOfQSObject(arg, QS_CONSTANT.SHARE_ID.KEY);

    //const { startMode: qStartMode, shareID: qShareID } = arg;
    const supportOnlyPCStartMode = [
      QS_CONSTANT.START_MODE.VALUES.NEW_DOC,
      QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC
    ];

    let startMode = qStartMode || QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;

    if (startMode === '') startMode = QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;
    if (qShareID !== undefined && qShareID !== '')
      startMode = QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW;

    if (
      isPCView === false &&
      //PC 에서만 허용하는 StartMode 일 때, 기본 모드로 변경
      supportOnlyPCStartMode.includes(startMode)
    )
      startMode = QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG;

    return startMode;
  },

  runShareView: () => {},
  run: (dispatch, i18n, recentFiles, { setRes, setSU, setShareID }) => {
    const query = getQSObject();
    const { isPCView, clientOS } = parseInfoFromUA();
    const startMode = USE_REACT_ROUTER
      ? AppMainProcess.getStartModeFromPath(location.pathname)
      : StandAloneProductProcess.getStartModeFromArg(query, isPCView);

    const getSdkMode = () => {
      switch (startMode) {
        case QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW: {
          if (
            DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SLIDE &&
            isPCView === false
          )
            return PO_EDIT_MODE.PRESENTATION;
          else return PO_EDIT_MODE.READ;
        }
        case QS_CONSTANT.START_MODE.VALUES.NEW_DOC:
        case QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC:
        case QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG:
        default: {
          if (
            (clientOS === MAC_OS_NAME &&
              DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.HWP) ||
            isPCView === false
          ) {
            if (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SLIDE)
              return PO_EDIT_MODE.PRESENTATION;
            else return PO_EDIT_MODE.READ;
          } else {
            return PO_EDIT_MODE.EDIT;
          }
        }
      }
    };

    switch (startMode) {
      case QS_CONSTANT.START_MODE.VALUES.NEW_DOC:
        ga.event({ category: '문서열기', action: '새문서', label: '파일탭' });
        const fileName = genNewFileName();
        dispatch(setFileName(fileName));
        dispatch(showPopupAD());
        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC:
        if (recentFiles) {
          try {
            const lastFile = recentFiles[0];
            if (lastFile) {
              const file = lastFile.file;
              let fileName = file.name;
              const tmpExt = `${CHANGE_FONT_TEMP_FILE_EXT}`;
              if (fileName.endsWith(tmpExt)) {
                fileName = fileName.substring(0, fileName.length - tmpExt.length);
              }
              setRes(file);
              dispatch(setFileName(fileName));
            } else {
              const fileName = genNewFileName();
              dispatch(setFileName(fileName));
            }
            dispatch(showPopupAD());
          } catch (error) {
            dispatch(
              showToast({
                msg: i18n.t('AppMain.RecentFileOpenError')
              })
            );
            ga.event({ category: '예외 케이스', action: '열람실패_DB오류' });
          }
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW:
        const su = getValueOfQSObject(query, QS_CONSTANT.SU.KEY);
        const qShareID = getValueOfQSObject(query, QS_CONSTANT.SHARE_ID.KEY);

        //const { shareID: qShareID, su } = query;
        if (su !== undefined) setSU(su === 'true');
        setShareID(qShareID);
        dispatch(setShareId(qShareID));
        if (isPCView === true) {
          dispatch(showPopupAD());
        } else {
          dispatch(showMobileBottomAD());
        }
        break;
      case QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG:
      default:
        dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_OPEN_DOCUMENT }));
        break;
    }

    dispatch(setEditMode(getSdkMode()));
  }
};

export default AppMainProcess;
